import {
    CoreApiFilterObject,
    FILTER_TYPES,
} from '@/coreApi/filters/coreApiFilterObject'

const FILTER_ID_PAGE_FILTER = 'pf'

const coreApiPageFilters = [
    {
        title: 'Referrers',
        key: 'r',
        field_name: 'referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Home',
                value: 'site_internal_home',
            },
            {
                label: 'Internal',
                value: 'site_internal',
            },
            {
                label: 'Infinite Scroll',
                value: 'site_internal_infinite_scroll',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Hurriyet',
                value: 'hurriyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'Source Referrers',
        key: 'ord',
        field_name: 'origin_referer_domain',
        filter_type: 'multiple-select',
        data: [
            {
                label: 'Direct',
                value: 'site_direct',
            },
            {
                label: 'Google Organic',
                value: 'search_google_organic',
            },
            {
                label: 'Google Amp',
                value: 'search_google_amp',
            },
            {
                label: 'Google News',
                value: 'search_google_new',
            },
            {
                label: 'Google CPC',
                value: 'search_google_cpc',
            },
            {
                label: 'Google Discover',
                value: 'search_google_discover',
            },
            {
                label: 'Facebook',
                value: 'social_facebook',
            },
            {
                label: 'Facebook Instance Article',
                value: 'social_facebook_instant_article',
            },
            {
                label: 'Instagram',
                value: 'social_instagram_referrer',
            },
            {
                label: 'Twitter',
                value: 'social_twitter_referrer',
            },
            {
                label: 'Milliyet',
                value: 'milliyet',
            },
            {
                label: 'Sabah',
                value: 'sabah',
            },
            {
                label: 'gazeteler.com',
                value: 'gazeteler.com',
            },
            {
                label: 'gazetekeyfi.com',
                value: 'gazetekeyfi',
            },
            {
                label: 'Yandex',
                value: 'yandex',
            },
            {
                label: 'Yahoo',
                value: 'yahoo',
            },
            {
                label: 'Sanalbasin',
                value: 'sanalbasin',
            },
            {
                label: 'f5haber.com',
                value: 'f5haber.com',
            },
            {
                label: 'eksisozluk.com',
                value: 'eksisozluk.com',
            },
            {
                label: 'Bundle',
                value: 'bundle',
            },
        ],
    },
    {
        title: 'UTM Referrers',
        key: 'ur',
        field_name: 'referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'UTM Source Referrers',
        key: 'usr',
        field_name: 'origin_referer_utm',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'bundle',
            'email',
            'f5haber',
            'facebook',
            'haberler.com',
            'gazetekeyfi',
            'gazeteoku',
            'google',
            'guncelhaberler',
            'webpush',
            't.co',
            'taboola',
        ],
    },
    {
        title: 'Devices',
        key: 'd',
        field_name: 'device',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Desktop',
                value: 'desktop',
            },
            {
                label: 'Mobile',
                value: 'mobile',
            },
            {
                label: 'Tablet',
                value: 'tablet',
            },
        ],
    },
    {
        title: 'Sources',
        key: 's',
        field_name: 'source',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Web',
                value: 'web',
            },
            {
                label: 'Amp',
                value: 'amp',
            },
            {
                label: 'Instance Article',
                value: 'ia',
            },
            {
                label: 'Android App',
                value: 'androidApp',
            },
            {
                label: 'IOS App',
                value: 'iosApp',
            },
        ],
    },
    {
        title: 'Domains',
        key: 'ds',
        field_name: 'page_domains',
        filter_type: 'checkbox',
        data: [
            {
                label: 'www.milliyet.com.tr',
                value: 'www.milliyet.com.tr,m.milliyet.com.tr',
            },
            {
                label: 'secim.milliyet.com.tr',
                value: 'secim.milliyet.com.tr',
            },
            {
                label: 'uzmanpara.milliyet.com.tr',
                value: 'uzmanpara.milliyet.com.tr,uzmanparam.milliyet.com.tr',
            },
        ],
    },
    {
        title: 'Categories',
        key: 'c',
        field_name: 'breadcrumb_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Gündem', value: 'gündem' },
            { label: 'Ekonomi', value: 'ekonomi' },
            { label: 'Siyaset', value: 'siyaset' },
            { label: 'Dünya', value: 'dünya' },
            { label: 'Skorer', value: 'skor' },
            { label: 'Cadde', value: 'cadde' },
            { label: 'Pembenar', value: 'pembenar' },
            { label: 'Yazarlar', value: 'yazarlar' },
            { label: 'Gazete Haberleri', value: 'gazete haberleri' },
            { label: 'Blog', value: 'Blog' },
            { label: 'Teknoloji', value: 'teknoloji' },
            { label: 'Kültür Sanat', value: 'kültür sanat' },
            { label: 'Milliyet Executive', value: 'Milliyet Executive' },
        ],
    },
    {
        title: 'Authors',
        key: 'a',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'Abbas Güçlü', value: 'abbas güçlü' },
            { label: 'Abdullah Karakuş', value: 'abdullah karakuş' },
            { label: 'Afşin Yakuboğlu', value: 'afşin yakuboğlu' },
            { label: 'Aksal Yavuz', value: 'aksal yavuz' },
            { label: 'Ali̇ Ağaoğlu', value: 'ali̇ ağaoğlu' },
            { label: 'Ali̇ Eyüboğlu', value: 'ali̇ eyüboğlu' },
            { label: 'Andaç Üzel', value: 'andaç üzel' },
            { label: 'Atilay Kandemir', value: 'atilay kandemir' },
            { label: 'Attila Gökçe', value: 'attila gökçe' },
            { label: 'Aziz Kedi', value: 'aziz kedi' },
            { label: 'Berk Karataş', value: 'berk karataş' },
            { label: 'Betül Topaklı', value: 'betül topaklı' },
            { label: 'Betül Yasemin Keskin', value: 'betül yasemin keskin' },
            { label: 'Betül Yergök', value: 'betül yergök' },
            { label: 'Beyhan Budak', value: 'beyhan budak' },
            { label: 'Bilal Meşe', value: 'bilal meşe' },
            { label: 'Çağdaş Ertuna', value: 'çağdaş ertuna' },
            { label: 'Cem ARITÜRK', value: 'cem aritürk' },
            { label: 'Cem Kiliç', value: 'cem kiliç' },
            { label: 'Cemal Ersen', value: 'cemal ersen' },
            { label: 'Ceren Gümüş Yaşa', value: 'ceren gümüş yaşa' },
            { label: 'Çetin Altan', value: 'çetin altan' },
            { label: 'Demet Erciyes', value: 'demet erciyes' },
            { label: 'Deniz İhsan Taşdelen-', value: 'deniz i̇hsan taşdelen-' },
            { label: 'Di̇Dem Özel Tümer', value: 'di̇dem özel tümer' },
            { label: 'Dilara Koçak', value: 'dilara koçak' },
            { label: 'E. Murat Tuzcu', value: 'e. murat tuzcu' },
            { label: 'E.Kübra Zeydanlı', value: 'e.kübra zeydanlı' },
            { label: 'Ebru KÜÇÜKGÖKDEMİR-', value: 'ebru küçükgökdemi̇r-' },
            { label: 'Ecem Bozbel', value: 'ecem bozbel' },
            { label: 'Ediz Sırapınar', value: 'ediz sırapınar' },
            { label: 'Emel Yılmaz', value: 'emel yılmaz' },
            { label: 'Ercan Güven', value: 'ercan güven' },
            { label: 'Esra Ertuğrul', value: 'esra ertuğrul' },
            { label: 'Esra Kocasoy', value: 'esra kocasoy' },
            { label: 'Esra Öz', value: 'esra öz' },
            { label: 'Fazilet Şenol', value: 'fazilet şenol' },
            { label: 'Fulya Eyilik', value: 'fulya eyilik' },
            { label: 'Gökçen Erdoğan', value: 'gökçen erdoğan' },
            { label: 'Gülçin Keskin', value: 'gülçin keskin' },
            { label: 'Güneri Cıvaoğlu', value: 'güneri cıvaoğlu' },
            { label: 'Hakki Öcal', value: 'hakki öcal' },
            { label: 'Harun Şimşek', value: 'harun şimşek' },
            { label: 'Hasan Pulur', value: 'hasan pulur' },
            { label: 'İlsun Aka-', value: 'i̇lsun aka-' },
            { label: 'Ipek Gökozan', value: 'ipek gökozan' },
            { label: 'İrem Küçükçongar-', value: 'i̇rem küçükçongar-' },
            { label: 'Jan Klod Kayuka', value: 'jan klod kayuka' },
            { label: 'Kurabiye Canavarı', value: 'kurabiye canavarı' },
            { label: 'Levent Kalkan', value: 'levent kalkan' },
            { label: 'Mayk Şişman', value: 'mayk şişman' },
            { label: 'Mehmet Can Kömürcü', value: 'mehmet can kömürcü' },
            { label: 'Mehmet Tez', value: 'mehmet tez' },
            { label: 'Melih Aşık', value: 'melih aşık' },
            { label: 'Merve Karataşlı', value: 'merve karataşlı' },
            { label: 'Mesut Aydın Kale', value: 'mesut aydın kale' },
            { label: 'Mete Belovacikli', value: 'mete belovacikli' },
            { label: 'Mete Utku', value: 'mete utku' },
            { label: 'Metin TOKER', value: 'metin toker' },
            { label: 'Mustafa Anıklı', value: 'mustafa anıklı' },
            { label: 'Nilüfer Pazvantoğlu', value: 'nilüfer pazvantoğlu' },
            { label: 'Osman Şenher', value: 'osman şenher' },
            { label: 'Özay Şendi̇R', value: 'özay şendi̇r' },
            { label: 'R.Hakan Kırkoğlu', value: 'r.hakan kırkoğlu' },
            { label: 'Reha Arar', value: 'reha arar' },
            { label: 'Rüya Salik', value: 'rüya salik' },
            { label: 'Sadık Gültekin', value: 'sadık gültekin' },
            { label: 'Sami̇ Kohen', value: 'sami̇ kohen' },
            { label: 'Şansal Büyüka', value: 'şansal büyüka' },
            { label: 'Şebnem Burcuoğlu', value: 'şebnem burcuoğlu' },
            { label: 'Seçkin İlbuğa-', value: 'seçkin i̇lbuğa-' },
            { label: 'Selami ÖKTEM', value: 'selami öktem' },
            { label: 'Selçuk Bulut', value: 'selçuk bulut' },
            { label: 'Selçuk İnanlı-', value: 'selçuk i̇nanlı-' },
            { label: 'Sercan Dinç', value: 'sercan dinç' },
            { label: 'Serkan Boğaç Yılmaz', value: 'serkan boğaç yılmaz' },
            { label: 'Sezai Leventoğlu', value: 'sezai leventoğlu' },
            { label: 'Sina Koloğlu', value: 'sina koloğlu' },
            { label: 'Sinan Akkurt', value: 'sinan akkurt' },
            { label: 'Süleyman Ateş', value: 'süleyman ateş' },
            { label: 'Taner Usta', value: 'taner usta' },
            { label: 'Tarkan Güveloğlu', value: 'tarkan güveloğlu' },
            { label: 'Tayfun Bayındır', value: 'tayfun bayındır' },
            { label: 'Tayfun Türkaslan', value: 'tayfun türkaslan' },
            { label: 'Tolga Sarı', value: 'tolga sarı' },
            { label: 'Tunca Bengi̇N', value: 'tunca bengi̇n' },
            { label: 'Turcel Orman', value: 'turcel orman' },
            { label: 'Ümit Avcı', value: 'ümit avcı' },
            { label: 'Uzay Gökerman', value: 'uzay gökerman' },
            { label: 'Verda Özer', value: 'verda özer' },
            { label: 'Yaşar Öksüz', value: 'yaşar öksüz' },
            { label: 'Zafer Şahin', value: 'zafer şahin' },
            { label: 'Zeynep Aktaş', value: 'zeynep aktaş' },
        ],
    },
    {
        title: 'Editors',
        key: 'ed',
        field_name: 'author_search',
        filter_type: 'multiple-select',
        data: [
            { label: 'adonmez', value: 'adonmez' },
            { label: 'aeldeniz', value: 'aeldeniz' },
            { label: 'aer', value: 'aer' },
            { label: 'agdaglimerve', value: 'agdaglimerve' },
            { label: 'akin.guler', value: 'akin.guler' },
            { label: 'aliozgur', value: 'aliozgur' },
            { label: 'arslanmesrure', value: 'arslanmesrure' },
            { label: 'asengir', value: 'asengir' },
            { label: 'aturna', value: 'aturna' },
            { label: 'bbulat', value: 'bbulat' },
            { label: 'bcetin', value: 'bcetin' },
            { label: 'Betül Topaklı', value: 'betül topaklı' },
            { label: 'bgencer', value: 'bgencer' },
            { label: 'bilsay.ozer', value: 'bozer' },
            { label: 'bkeskin', value: 'bkeskin' },
            { label: 'bsenel', value: 'bsenel' },
            { label: 'bugra.kolagasigil', value: 'mbugra' },
            { label: 'burcu.sahinkaya1', value: 'burcu.sahinkaya1' },
            { label: 'buse-gundogan', value: 'buse-gundogan' },
            { label: 'busra.koksal', value: 'busra.koksal' },
            { label: 'cansu.kocaman', value: 'cansu.kocaman' },
            { label: 'ckocaman', value: 'ckocaman' },
            { label: 'csisman', value: 'csisman' },
            { label: 'dbay', value: 'dbay' },
            { label: 'dgokce', value: 'dgokce' },
            { label: 'dkoc', value: 'dkoc' },
            { label: 'dsssdcicek', value: 'dsssdcicek' },
            { label: 'dtasdelen', value: 'dtasdelen' },
            { label: 'duygu.bay', value: 'duygu.bay' },
            { label: 'edemir', value: 'edemir' },
            { label: 'emengi', value: 'emengi' },
            { label: 'emre.gunayi', value: 'egunayi' },
            { label: 'eozdemir', value: 'eozdemir' },
            { label: 'etopaloglu', value: 'etopaloglu' },
            { label: 'EYLÜL AKTAN', value: 'eylül aktan' },
            { label: 'fazisenol', value: 'fazisenol' },
            { label: 'fsenol', value: 'fsenol' },
            { label: 'gizem.aydogan', value: 'gizem.aydogan' },
            { label: 'gkaraman', value: 'gkaraman' },
            { label: 'gkaratas', value: 'gkaratas' },
            { label: 'gkocabas', value: 'gkocabas' },
            { label: 'gulsah.kahraman', value: 'gulsah.kahraman' },
            { label: 'gunay.cagrici', value: 'gunay.cagrici' },
            { label: 'h.ozdemir', value: 'h.ozdemir' },
            { label: 'hakankanburoglu', value: 'hakankanburoglu' },
            { label: 'hande.guney', value: 'hande.guney' },
            { label: 'hcetinkaya', value: 'hcetinkaya' },
            { label: 'hkurt', value: 'hkurt' },
            { label: 'hnarin', value: 'hnarin' },
            { label: 'idil.demiray', value: 'idil.demiray' },
            { label: 'idindar', value: 'idindar' },
            { label: 'kzimba', value: 'kzimba' },
            { label: 'maydin', value: 'maydin' },
            { label: 'mefe', value: 'mefe' },
            { label: 'mekinci', value: 'mekinci' },
            { label: 'mesut.kale', value: 'mesut.kale' },
            { label: 'mete.sevilir', value: 'mete.sevilir' },
            { label: 'mkale', value: 'mkale' },
            { label: 'msevilir', value: 'msevilir' },
            { label: 'mtemiz', value: 'mtemiz' },
            { label: 'mustafa.efe', value: 'mustafa.efe' },
            { label: 'nazlihan.erdol', value: 'nazlihan.erdol' },
            { label: 'nberk', value: 'nberk' },
            { label: 'nkamu', value: 'nkamu' },
            { label: 'oatis', value: 'oatis' },
            { label: 'oguzcana', value: 'oguzcana' },
            { label: 'oktayozturk', value: 'oktayozturk' },
            { label: 'onur.binay', value: 'onur.binay' },
            { label: 'orcun.aydinoglu', value: 'orcun.aydinoglu' },
            { label: 'otopkan', value: 'otopkan' },
            { label: 'ozgur.pinar', value: 'ozgur.pinar' },
            { label: 'ozlem.temana', value: 'ozlem.temana' },
            { label: 'proje', value: 'proje' },
            { label: 'sbarut', value: 'sbarut' },
            { label: 'sbulut', value: 'sbulut' },
            { label: 'selen.yesilyurt', value: 'selen.yesilyurt' },
            { label: 'senim.tanay', value: 'senim.tanay' },
            { label: 'sercan.dinc', value: 'sercan.dinc' },
            { label: 'sercandinc', value: 'sercandinc' },
            { label: 'serpil.dokurel', value: 'serpil.dokurel' },
            { label: 'sila.aggul', value: 'sila.aggul' },
            { label: 'sistem', value: 'sistem' },
            { label: 'sozen', value: 'sozen' },
            { label: 'syesilyurt', value: 'syesilyurt' },
            { label: 'thos', value: 'thos' },
            { label: 'tkaralar', value: 'tkaralar' },
            { label: 'ukurban', value: 'ukurban' },
            { label: 'vsahin', value: 'vsahin' },
            { label: 'wesserbest', value: 'wesserbest' },
        ],
    },
    {
        title: 'User Type',
        key: 'ut',
        field_name: 'user_types',
        filter_type: 'checkbox',
        data: [
            {
                label: 'Anonymous',
                value: 'anonymous',
            },
            {
                label: 'Paid',
                value: 'paid',
            },
            {
                label: 'Logged In',
                value: 'loggedin',
            },
        ],
    },
    {
        title: 'Keywords',
        key: 'kw',
        field_name: 'keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Keywords Exclude',
        key: 'kwn',
        field_name: 'not_keywords',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            'seohaber',
        ],
    },
    {
        title: 'Search',
        key: 'srch',
        field_name: 'search_include',
        filter_type: 'search_autosuggest',
        filter_value_lowercase: true,
        data: [
            '404 hata sayfası',
        ],
    },
]

// eslint-disable-next-line import/prefer-default-export
export const coreApiPageFilterMilliyetcomObject = new CoreApiFilterObject(FILTER_ID_PAGE_FILTER, FILTER_TYPES.VALUES, coreApiPageFilters)
